import axios from 'axios';
import AppConfig from "../../../AppConfig";

let URL = AppConfig.HOST_API() + 'pracownicy/'

export default {


    getPracownicy() {
        return axios({
            method: 'get',
            url: URL + '?page=0&size=9999',
        });
    },

    getPracownik(id) {
        return axios({
            method: 'get',
            url: URL + id,
        });
    },

    addPracownik(data) {
        return axios({
            method: 'post',
            url: URL,
            data: JSON.stringify(data),
        })
    },

    editPracownik(id, data) {
        return axios(
            {
                url: URL + id,
                method: 'put',
                data: JSON.stringify(data),
            }
        )
    },

    deletePracownik(id) {
        return axios({
                url: URL + id,
                method: 'delete',
            }
        )
    },

}


// WEBPACK FOOTER //
// ./src/modules/administracja/pracownicy/PracownicyService.js